module.exports = __webpack_public_path__ + "static/media/telegram-light.fcc8f497.svg";